export const CTATypeItems = [
  "custom_url",
  "player_short_link",
  "player_website",
  "player_card",
  "form_link",
  "smart_link",
  "player_phone",
  "custom_phone",
  "player_sms",
  "custom_sms",
  "player_email",
  "custom_email",
] as const;
export type CTAType = (typeof CTATypeItems)[number];

const CustomCTATypeItems = ["custom_url", "custom_phone", "custom_email", "custom_sms"] as const;
export const isCustomCTAType = (type: CTAType): boolean => (CustomCTATypeItems as readonly CTAType[]).includes(type);

export type CTA = {
  label: string;
  type: CTAType;
  customLink: string | null;
  formId?: number | null;
  smartLinkId?: number | null;
  destinationLabel?: string | null;
};

/** Strips API-only fields (e.g. `id`) so form dirty-checking stays stable. */
export function normalizeCTA(cta: CTA | null | undefined): CTA | null {
  if (!cta) return null;
  return {
    label: cta.label,
    type: cta.type,
    customLink: cta.customLink ?? null,
    formId: cta.formId ?? null,
    smartLinkId: cta.smartLinkId ?? null,
    destinationLabel: cta.destinationLabel ?? null,
  };
}

export const stripCTAPrefix = (value: string | null | undefined, prefix?: string): string => {
  if (!value) return "";
  if (!prefix) return value;
  if (value.toLowerCase().startsWith(prefix.toLowerCase())) {
    return value.slice(prefix.length);
  }
  if (prefix === "https://" && value.toLowerCase().startsWith("http://")) {
    return value.slice("http://".length);
  }
  return value;
};

export const withCTAPrefix = (value: string, prefix?: string): string => {
  if (!prefix || !value) return value;
  if (value.toLowerCase().startsWith(prefix.toLowerCase())) return value;
  if (prefix === "https://" && value.toLowerCase().startsWith("http://")) return value;
  if (prefix === "https://" && /^[a-z][a-z0-9+.-]*:/i.test(value)) return value;
  return `${prefix}${value}`;
};
